import type { ReactNode } from 'react';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import { cn } from '@/lib/cn';

interface DialogProps {
  children: ReactNode;
  description?: string;
  onOpenChange?: (open: boolean) => void;
  open: boolean;
  title: string;
}

export function Dialog({ children, description, onOpenChange, open, title }: DialogProps) {
  return (
    <DialogPrimitive.Root onOpenChange={onOpenChange} open={open}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className="fixed inset-0 z-50 bg-black/65 backdrop-blur-sm data-[state=open]:animate-[fade_.15s_ease-out]" />
        <DialogPrimitive.Content
          className={cn(
            'fixed inset-x-3 bottom-3 z-50 max-h-[calc(100dvh-1.5rem)] overflow-y-auto rounded-2xl border border-line bg-surface p-5 shadow-lift',
            'sm:left-1/2 sm:top-1/2 sm:bottom-auto sm:w-[min(92vw,34rem)] sm:-translate-x-1/2 sm:-translate-y-1/2 sm:p-6'
          )}
        >
          <div className="mb-5 pr-10">
            <DialogPrimitive.Title className="font-display text-xl font-bold tracking-tight text-ink">
              {title}
            </DialogPrimitive.Title>
            {description ? (
              <DialogPrimitive.Description className="mt-1.5 text-sm leading-relaxed text-muted">
                {description}
              </DialogPrimitive.Description>
            ) : null}
          </div>
          {children}
          <DialogPrimitive.Close
            aria-label="Dialog schließen"
            className="absolute right-3 top-3 grid size-11 place-items-center rounded-xl text-muted hover:bg-elevated hover:text-ink"
          >
            <X aria-hidden="true" className="size-5" />
          </DialogPrimitive.Close>
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
}
